import { Model, Factory } from 'miragejs'
import { randPastDate, randFutureDate, randChanceBoolean } from '@ngneat/falso'

import type { ModelDefinition } from 'miragejs/-types'
import type { SchemaAttributes } from '../types.js'

export type LocumAssignmentData = SchemaAttributes<'LocumAssignment'>

export const model = Model.extend({}) as ModelDefinition<LocumAssignmentData>

export const factory = Factory.extend<LocumAssignmentData>({
  start_date() {
    return randPastDate({ years: 1 }).toISOString().split('T')[0]
  },
  end_date() {
    return randChanceBoolean({ chanceTrue: 0.7 })
      ? randFutureDate({ years: 1 }).toISOString().split('T')[0]
      : null
  },
  archived() {
    return randChanceBoolean({ chanceTrue: 0.25 })
  },
  created() {
    return randPastDate({ years: 2 }).toISOString()
  },
  modified() {
    return randPastDate({ years: 1 }).toISOString()
  },
  is_upcoming() {
    return randChanceBoolean({ chanceTrue: 0.25 })
  },
  is_active() {
    return randChanceBoolean({ chanceTrue: 0.75 })
  },
  is_past() {
    return randChanceBoolean({ chanceTrue: 0.25 })
  },
})
